// import Vue from 'vue';
import VueTippy from 'vue-tippy';
import Vue3Lazyload from 'vue3-lazyload';
import { vMaska } from 'maska/vue';
import PortalVue from 'portal-vue';
import VeProgress from 'vue-ellipse-progress';
// own components;
import SvgSprite from './views/common/VueComponents/VueIcon/svgSprite.vue';
import VgpButton from '$$vueCmp/globalButton/vgpButton.vue';
import VgpInput from '$$vueCmp/vInput/vgpInput.vue';
import VgpCheckbox from '$$vueCmp/checkbox/vgpCheckbox.vue';
import corePopup from '$$vueCmp/popups/corePopup/corePopup.vue';
import colorPalette from '$$vueCmp/colorPalette/colorPalette.vue';
import statusSelect from '$$vueCmp/select/statusSelect/statusSelect.vue';
import VgpTabs from './views/common/VueComponents/tabs/vgpTabs.vue';
import Header from './views/header/header.vue';
import Footer from './views/footer/footer.vue';
import LeftSideBar from './views/leftSideBar/leftSideBar.vue';
import GlobalPopup from '$$vueCmp/popups/globalPopup/globalPopup.vue';
import PassStrengthPopup from '$$vueCmp/popups/passStrengthPopup/passStrengthPopup.vue';
import tooltip from './views/tooltip/tooltip.vue';
import PaymentPlans from './views/paymentPlans/paymentPlans.vue';
import StudentsPage from './views/paymentPlans/studentsPage/studentsPage.vue';
import VueGallery from './views/vueGallery/VueGallery.vue';
import infoPopup from '$$vueCmp/popups/infoPopup/infoPopup.vue';
import MaintenanceNotification from '$$vueCmp/maintenanceNotification/maintenanceNotification.vue';
import contextMenuPopup from '$$vueCmp/popups/contextMenuPopup/contextMenuPopup.vue';
import VgpAvatar from '$$vueCmp/avatar/vgpAvatar.vue';
import VgpRowInput from '$$vueCmp/vInput/vgpRowInput.vue';
import WebixUIComponent from './views/common/WebixUIComponent.vue';
import constants from '$$helpers/constants';
import videoComponent from '$$vueCmp/video/videoComponent.vue';
import vClickOutside from './plugins/directives/vClickOutside';
import vScroll from './plugins/directives/vScroll';
import vClickOutsideMousedown from './plugins/directives/vClickOutsideMousedown';

export function initVgpVueComponents(vueApp) {
  vueApp.component('SvgSprite', SvgSprite);
  vueApp.component('VgpButton', VgpButton);
  vueApp.component('VgpInput', VgpInput);
  vueApp.component('VgpCheckbox', VgpCheckbox);
  vueApp.component('VgpCorePopup', corePopup);
  vueApp.component('VgpColorPalette', colorPalette);
  // vueApp.component('HeaderVue', Header);
  // vueApp.component('FooterVue', Footer);
  vueApp.component('MaintenanceNotification', MaintenanceNotification);
  // vueApp.component('LeftSidebarVue', LeftSideBar);
  vueApp.component('GlobalPopup', GlobalPopup);
  vueApp.component('PassStrengthPopup', PassStrengthPopup);
  vueApp.component('TooltipPopup', tooltip);
  vueApp.component('PaymentPlans', PaymentPlans);
  vueApp.component('StudentsPage', StudentsPage);
  vueApp.component('VueGallery', VueGallery);
  vueApp.component('VgpTabs', VgpTabs);
  vueApp.component('StatusSelect', statusSelect);
  vueApp.component('InfoPopup', infoPopup);
  vueApp.component('ContextMenu', contextMenuPopup);
  vueApp.component('VgpAvatar', VgpAvatar);
  vueApp.component('VgpRowInput', VgpRowInput);
  vueApp.component('WebixUi', WebixUIComponent);
  vueApp.component('VideoComponent', videoComponent);

  // use dependencies
  vueApp.use(Vue3Lazyload);
  vueApp.use(PortalVue);
  vueApp.use(VueTippy, {
    component: 'tippy',
    directive: 'tippy',
    arrow: true,
    defaultProps: {
      placement: 'auto-end',
      allowHTML: true,
      appendTo: () => document.body,
      duration: [300, 0],
      popperOptions: {
        modifiers: [
          {
            name: 'preventOverflow',
            options: {
              boundary: 'window',
            },
          },
        ],
      },
    },
  });
  vueApp.use(VeProgress);

  vueApp.directive('click-outside', vClickOutside);
  vueApp.directive('scroll', vScroll);
  vueApp.directive('maska', vMaska);
  vueApp.directive('click-outside-mousedown', vClickOutsideMousedown);
}

export default {};
